var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pay-trans-details" },
    [
      _c(
        "div",
        { staticClass: "filter-right-container" },
        [
          _c("div", { staticClass: "filter-container-tag" }, [
            _vm._v(" " + _vm._s(_vm.$t("components.activity")) + " "),
          ]),
          _c(
            "el-popover",
            { attrs: { placement: "bottom", trigger: "click" } },
            [
              _c("div", { staticClass: "filter-section-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "filter-content",
                    attrs: { id: "filter-content" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "times", $$v)
                            },
                            expression: "search.times",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("merchantAccount.complete_time")) +
                              " "
                          ),
                        ]),
                        _c("el-date-picker", {
                          staticClass: "filter-item-value",
                          attrs: {
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd HH:mm:ss",
                            "default-time": ["00:00:00", "23:59:59"],
                            type: "daterange",
                            "range-separator": "~",
                            "start-placeholder": _vm.$t(
                              "components.start_date"
                            ),
                            "end-placeholder": _vm.$t("components.end_date"),
                          },
                          model: {
                            value: _vm.search.response_times,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "response_times", $$v)
                            },
                            expression: "search.response_times",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("merchant.payment_channel"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { filterable: "", clearable: "" },
                            model: {
                              value: _vm.search.channel_code,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "channel_code", $$v)
                              },
                              expression: "search.channel_code",
                            },
                          },
                          _vm._l(
                            _vm.compFilterPaymentChannel,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.channel_code,
                                  value: item.channel_code,
                                },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("merchantAccount.transaction_status"))
                          ),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.search.transaction_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "transaction_status", $$v)
                              },
                              expression: "search.transaction_status",
                            },
                          },
                          _vm._l(
                            _vm.payTransactionStatusArr,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("data.settlement_status"))),
                        ]),
                        _c(
                          "el-select",
                          {
                            staticClass: "filter-item-value",
                            attrs: { clearable: "" },
                            model: {
                              value: _vm.search.settlement_status,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "settlement_status", $$v)
                              },
                              expression: "search.settlement_status",
                            },
                          },
                          _vm._l(
                            _vm.transactionSettlementStatusMap,
                            function (item, index) {
                              return _c("el-option", {
                                key: index,
                                attrs: { label: item.label, value: item.value },
                              })
                            }
                          ),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.transaction_id"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { type: "text", clearable: "" },
                          model: {
                            value: _vm.search.transaction_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "transaction_id", $$v)
                            },
                            expression: "search.transaction_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("customerService.merchant_order_id"))
                          ),
                        ]),
                        _c("el-input", {
                          staticClass: "filter-item-value",
                          attrs: { type: "text", clearable: "" },
                          model: {
                            value: _vm.search.merchant_order_id,
                            callback: function ($$v) {
                              _vm.$set(_vm.search, "merchant_order_id", $$v)
                            },
                            expression: "search.merchant_order_id",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("operation.business"))),
                        ]),
                        _c("ScopeSelect", {
                          staticClass: "filter-item-value",
                          attrs: {
                            value: _vm.search.business_id,
                            "is-remote": true,
                            "http-request-method": _vm.searchBusinessOptions,
                            "remote-params": _vm.getBusinessSearchParams,
                            "option-label": _vm.formatBusinessOption,
                            "select-placeholder": _vm.$t(
                              "operation.select_business"
                            ),
                          },
                          on: {
                            updateValue: function ($event) {
                              _vm.search.business_id = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "filter-item" },
                      [
                        _c("div", { staticClass: "filter-item-label" }, [
                          _vm._v(_vm._s(_vm.$t("operation.franchisee"))),
                        ]),
                        _c("ScopeSelect", {
                          staticClass: "filter-item-value",
                          attrs: {
                            value: _vm.search.franchisee_id,
                            "is-remote": true,
                            "http-request-method": _vm.searchFranchiseeOptions,
                            "remote-params": _vm.getFranchiseeSearchParams,
                            "option-label": _vm.formatFranchiseeOption,
                            "select-placeholder": _vm.$t(
                              "operation.select_franchisee"
                            ),
                          },
                          on: {
                            updateValue: function ($event) {
                              _vm.search.franchisee_id = $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "filter-item" }),
                    _c("div", { staticClass: "filter-item" }),
                  ]
                ),
                _c("div", { staticClass: "filter-operate" }, [
                  _c(
                    "div",
                    { staticClass: "filter-operate-right" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          on: { click: _vm.onClickReset },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.clear")))]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "search-btn mb-10",
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter },
                        },
                        [_vm._v(_vm._s(_vm.$t("components.search")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "mb-10 mr-12",
                  attrs: { slot: "reference", type: "info", plain: "" },
                  slot: "reference",
                },
                [
                  _c("svg-icon", {
                    attrs: { "class-name": "mr-10", "icon-class": "filter" },
                  }),
                  _vm._v(_vm._s(_vm.$t("components.filter"))),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-button",
            {
              staticClass: "mb-10 download-btn",
              attrs: { plain: "", loading: _vm.downloading, type: "info" },
              on: { click: _vm.onClickDowmloadBtn },
            },
            [
              _c("svg-icon", { attrs: { "icon-class": "download" } }),
              _vm._v(" " + _vm._s(_vm.$t("components.download"))),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "total-container" }, [
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.total_count"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(_vm._s(_vm.total_count)),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.total_amount"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(_vm._f("toDivideWithDot")(_vm.total_amount))
            ),
          ]),
        ]),
        _c("div", { staticClass: "total-item" }, [
          _c("div", { staticClass: "total-item-text" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.total_fee"))),
          ]),
          _c("div", { staticClass: "color-main-linear-blue total-item-num" }, [
            _vm._v(
              _vm._s(_vm.$store.getters.currency) +
                " " +
                _vm._s(_vm._f("toDivideWithDot")(_vm.total_fee))
            ),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "tableContainer" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                stripe: "",
                fit: "",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("customerService.transaction_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.transaction_id))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.merchant_order_id"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.merchant_order_id)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchant.payment_channel"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.channel_code))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.transaction_status"),
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getPayTransStatusType(
                                scope.row.transaction_status
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getPayTransStatusLabel(
                                  scope.row.transaction_status
                                )
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchantAccount.transaction_amount"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(
                                scope.row.transaction_amount
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("merchant.service_fee"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("toDivideWithDot")(scope.row.fee_split)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchantAccount.create_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.transaction_create_time) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("merchantAccount.complete_time"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.transaction_return_time)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operation.business"),
                  "min-width": "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "copyable-no",
                            on: {
                              click: function ($event) {
                                return _vm.copyNumber(scope.row.business_no)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.business_no || "-"))]
                        ),
                        _c("div", { staticClass: "secondary-text" }, [
                          _vm._v(_vm._s(scope.row.business_name || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("operation.franchisee"),
                  "min-width": "150",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "copyable-no",
                            on: {
                              click: function ($event) {
                                return _vm.copyNumber(scope.row.franchisee_no)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.franchisee_no || "-"))]
                        ),
                        _c("div", { staticClass: "secondary-text" }, [
                          _vm._v(_vm._s(scope.row.franchisee_name || "-")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  "min-width": "110",
                  label: _vm.$t("data.remark"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.remark))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("components.operation"),
                  align: "center",
                  "min-width": "130",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.$store.getters.authorities.includes(
                          "AUTH_CODE_PAYMENT_REFUND"
                        )
                          ? _c(
                              "el-popover",
                              { attrs: { placement: "top", trigger: "click" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-align-center" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "operation-click-text-default",
                                        on: {
                                          click: function ($event) {
                                            return _vm.onClickDetailTxt(
                                              scope.row
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("components.detail"))
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      { attrs: { placement: "top" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "content" },
                                            slot: "content",
                                          },
                                          [
                                            [1, 4, 5, 6, 8, 9].includes(
                                              scope.row
                                                .refund_not_support_reason
                                            )
                                              ? _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tips.refund_tip_1"
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("br"),
                                                ])
                                              : [2, 3].includes(
                                                  scope.row
                                                    .refund_not_support_reason
                                                )
                                              ? _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tips.refund_tip_2"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : [7].includes(
                                                  scope.row
                                                    .refund_not_support_reason
                                                )
                                              ? _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "tips.refund_tip_3"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ])
                                              : _c("span", [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "components.refund"
                                                        )
                                                      )
                                                  ),
                                                  _c("br"),
                                                ]),
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              margin: "5px 0",
                                              border: "none",
                                              "font-size": "14px",
                                            },
                                            attrs: {
                                              type: "primary",
                                              size: "small",
                                              plain: "",
                                              disabled: !(
                                                scope.row
                                                  .original_refund_status &&
                                                scope.row
                                                  .original_refund_status !== 1
                                              ),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.onClickRefundTxt(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("components.refund")
                                              ) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      cursor: "pointer",
                                      padding: "5px",
                                    },
                                    attrs: { slot: "reference" },
                                    slot: "reference",
                                  },
                                  [_vm._v(" ••• ")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        !_vm.$store.getters.authorities.includes(
                          "AUTH_CODE_PAYMENT_REFUND"
                        )
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "info",
                                    size: "small",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onClickDetailTxt(scope.row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("components.view_details")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              !_vm.listLoading
                ? _c("paginator", {
                    attrs: { "list-query": _vm.listQuery },
                    on: { "paginator-change": _vm.onClickPaginator },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c("payment-details-modal", {
        ref: "paymentDetailsModal",
        attrs: { "detail-id": _vm.detailId },
      }),
      _c("payment-refund-modal", {
        ref: "paymentRefundModal",
        attrs: { "detail-id": _vm.detailId },
        on: { updatelist: _vm.handleFilter },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }